import { render, staticRenderFns } from "./report_simulation.vue?vue&type=template&id=07c8068b&scoped=true"
import script from "./report_simulation.vue?vue&type=script&lang=js"
export * from "./report_simulation.vue?vue&type=script&lang=js"
import style0 from "./report_simulation.vue?vue&type=style&index=0&id=07c8068b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c8068b",
  null
  
)

export default component.exports